import {
  PurchaseOrderModel,
  PurchasesOrderItem,
  SuccessfulAirtimePurchase,
  SuccessfulPurchase,
} from "../../../../../domain/usecases/get-account-balances";
import { classNames, currencyFormatter } from "../../../../utils/helpers";
import pdf from "../../../../assets/pdf.svg";
// import pdf from "../../../../assets/icons8-pdf-48.png";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Loading from "../../../../components/loading/loading";
import { useRecoilValue } from "recoil";
import { currentAccountState } from "../../../../components";

import { printTax } from "./printTax";
import { printDSTVReceipt } from "./printDSTVReceipt";
import { printAirtimeReceipt } from "./printAirtimeReceipt";

import { printTaxUnregistered } from "./printTaxUnregistered";
import { printDSTVUnregistered } from "./printDSTVUnregistered";
import { printAirtimeUnregistered } from "./printAirtimeUnregistered";

import { print } from "./print";

import { dashboardState } from "../../atoms/atoms";
import { useCallback, useEffect, useState } from "react";
import { format } from "date-fns";
import { DownloadIcon } from "@heroicons/react/outline";
import {
  Timestamp,
  collection,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../../../main/firebase";

const statusStyles: { [key: string]: string } = {
  completed: "bg-green-100 text-green-800",
  successful: "bg-green-100 text-green-800",
  logged: "bg-yellow-100 text-yellow-800",
  approved: "bg-yellow-100 text-yellow-800",
  processing: "bg-yellow-100 text-yellow-800",
  failed: "bg-red-100 text-red-800",
  rejected: "bg-red-100 text-red-800",
  "fatal failed": "bg-red-100 text-red-800",
};

type Props = {
  transaction: PurchaseOrderModel;
};

export default function TransactionDetailsRow({ transaction }: Props) {
  const { getCurrentAccount } = useRecoilValue(currentAccountState);
  const providers = useRecoilValue(dashboardState).providers;
  const [items, setItems] = useState([]);

  console.log("transaction details", transaction);

  useEffect(() => {
    const q = query(
      collection(db, "purchaseOrderLineItem"),
      where("purchaseOrderNo", "==", transaction.purchaseOrderNo)
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const data = querySnapshot.docs.map((d) => {
        let doc = d.data();
        // console.log("doc.dateCreated!", doc.dateCreated);
        // console.log("doc.dateUpdated!", doc.dateUpdated);
        return {
          account: doc.account,
          status: doc.status,
          merchant: doc.accountName,
          location: doc.location ? doc.location : null,
          name: doc.name ? doc.name : null,
          company: doc.company,
          owner: doc.registeredOwner ? doc.registeredOwner : doc.owner,
          jobTitle: doc.jobTitle ? doc.jobTitle : null,
          network: doc.network ? doc.network : null,
          number: doc.itemNumber,
          amount: doc.amount,
          itemType: doc.itemType,
          response: doc.response,
          // purchaseOrderId: doc.data().purchaseOrderId,
          dateUpdated: doc.dateUpdated.toDate(),
          dateCreated: doc.dateCreated.toDate(),
          lastPurchaseDate: doc.lastPurchaseDate,
          lastPurchaseAmount: doc.lastPurchaseAmount,
        } as PurchasesOrderItem;
      });

      setItems(data);
    });

    //remember to unsubscribe from your realtime listener on unmount or you will create a memory leak
    return () => unsubscribe();
  }, [transaction.purchaseOrderNo]);

  // const [data, setData] = useState([]);

  const [failureMeter, setFailureMeter] = useState(null);
  const [failureTransaction, setFailureTransaction] = useState(null);

  const provider = providers.find(
    (p) => p.product === transaction.purchaseOrderType
  );

  const buildFailureTable = (
    transaction: PurchaseOrderModel,
    item: PurchasesOrderItem
  ) => {
    console.log("item", item);
    setFailureMeter(item);
    setFailureTransaction(transaction);
  };

  const printFailureTable = useCallback(() => {
    // setFailureMeter(item);

    if (failureMeter === null) {
      return;
    }

    const doc = new jsPDF();

    var imgData =
      "data:image/png;base64,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";

    doc.setFontSize(40);

    doc.addImage(imgData, "PNG", 14, 20, 38.25, 5.4);
    // doc.output("datauri");

    doc.setFontSize(22);
    doc.text(`Failed Transaction`, 56, 25.5);
    doc.setTextColor(100);

    doc.setFontSize(12);
    doc.text(`Purchase Number - ${failureTransaction.purchaseOrderId}`, 14, 44);
    doc.setTextColor(100);

    autoTable(doc, {
      theme: "plain",
      headStyles: { fontSize: 10, fontStyle: "bold" },
      bodyStyles: { fontSize: 10, fontStyle: "normal" },
      styles: { cellPadding: 0.5 },
      startY: 48,
      head: [
        [
          "Order Reference",
          "Submitted By",
          "Approved By",
          "Date of Submission",
        ],
      ],
      body: [
        [
          `${failureTransaction.purchaseOrderReference}`,
          `${failureTransaction.initiator}`,
          `${failureTransaction.approver}`,
          `${format(failureTransaction.date, "yyyy-MM-dd HH:mm:ss")}`,
        ],
      ],
    });

    doc.line(195.5, 66, 14, 66);

    autoTable(doc, { html: "#failure-table", startY: 76 });

    doc.save(`${failureTransaction.id}.pdf`);
  }, [failureTransaction, failureMeter]);

  useEffect(() => {
    printFailureTable(); // This is be executed when `loading` state changes
  }, [failureTransaction, failureMeter]);

  const electricityHeader = () => {
    return (
      <>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          <div>Meter Name &amp;</div>
          <div>Location</div>
        </th>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          <div>Meter Number &amp;</div>
          <div>Registered Owner</div>
        </th>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          Status
        </th>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          Amount
        </th>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          <DownloadIcon
            className="text-gray-900 ml-1 h-5 w-5 group-hover:text-gray-900 "
            aria-hidden="true"
          />
        </th>
      </>
    );
  };

  const airtimeHeader = () => {
    return (
      <>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          <div>Owner &amp;</div>
          <div>Job Title</div>
        </th>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          <div>Network &amp;</div>
          <div>Number</div>
        </th>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          Status &amp; Serial Number
        </th>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          Amount
        </th>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          <DownloadIcon
            className="text-gray-900 ml-1 h-5 w-5 group-hover:text-gray-900 "
            aria-hidden="true"
          />
        </th>
      </>
    );
  };

  const dstvHeader = () => {
    return (
      <>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          <div>Smartcard Name &amp;</div>
          <div>Location</div>
        </th>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          <div>Smartcard Number &amp;</div>
          <div>Owner</div>
        </th>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          Status &amp; Reference
        </th>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          Amount
        </th>
        <th
          scope="col"
          className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
        >
          <DownloadIcon
            className="text-gray-900 ml-1 h-5 w-5 group-hover:text-gray-900 "
            aria-hidden="true"
          />
        </th>
      </>
    );
  };

  const tableHeader: { [key: string]: JSX.Element } = {
    electricity: electricityHeader(),
    airtime: airtimeHeader(),
    dstv: dstvHeader(),
  };

  const electricityRow = () => {
    console.log("Purchase order line items", items);
    return (
      transaction.purchaseOrderType === "ELECTRICITY" &&
      items.map((item, itemIdx) => (
        <tr key={item.number} className="border-b border-gray-150">
          <td className="px-4 py-1 whitespace-nowrap text-sm font-normal">
            <span className="text-sm text-gray-500">{item.name}</span>
            <br />
            <span className="text-sm font-medium text-gray-900">
              {item.location}
            </span>
          </td>

          <td className="px-4 py-1 whitespace-nowrap">
            <span className="text-sm text-gray-500">{item.number}</span>
            <br />
            <span className="text-sm font-medium text-gray-900 capitalize">
              {item.owner.toLowerCase()}
            </span>
          </td>

          <td className="px-4 py-1 whitespace-nowrap text-sm font-normal text-gray-500">
            <span
              className={classNames(
                statusStyles[item.status.toLowerCase()],
                "inline-flex items-center px-2 py-1 rounded-md text-md font-medium capitalize"
              )}
            >
              {item.status === "SUCCESSFUL" ? (
                <div className="flex flex-col">
                  <div>
                    {
                      (item.response as SuccessfulPurchase).creditVendReceipt
                        .keychangetoken1
                    }
                  </div>
                  <div>
                    {
                      (item.response as SuccessfulPurchase).creditVendReceipt
                        .keychangetoken2
                    }
                  </div>
                  <div>
                    {
                      (item.response as SuccessfulPurchase).creditVendReceipt
                        .stsCipher
                    }
                  </div>
                </div>
              ) : item.status === "LOGGED" ? (
                "approved"
              ) : item.status === "FATAL FAILED" ? (
                "FATAL FAILURE"
              ) : (
                item.status
              )}
            </span>
          </td>
          <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500">
            <span className="text-gray-900 font-bold">
              {currencyFormatter(item.amount)}
            </span>
          </td>
          {item.status === "SUCCESSFUL" ||
          item.status === "FAILED" ||
          item.status === "FATAL FAILED" ? (
            <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500  my-auto">
              <div className="block cursor-pointer h-7 w-auto">
                <img
                  className="text-gray-400 h-6 w-6 group-hover:text-gray-900"
                  aria-hidden="true"
                  onClick={() =>
                    item.status === "SUCCESSFUL"
                      ? item.company.name === "Not Registered"
                        ? printTaxUnregistered(
                            item,
                            itemIdx,
                            getCurrentAccount(),
                            provider
                          )
                        : printTax(item, itemIdx, getCurrentAccount(), provider)
                      : buildFailureTable(transaction, item)
                  }
                  src={pdf}
                  alt="Download"
                />
              </div>
            </td>
          ) : (
            <td> {""}</td>
          )}
        </tr>
      ))
    );
  };

  const airtimeRow = () => {
    return (
      transaction.purchaseOrderType === "AIRTIME" &&
      items.map((item, itemIdx) => (
        <tr key={item.number} className="border-b border-gray-150">
          <td className="px-4 py-1 whitespace-nowrap text-sm font-normal">
            <span className="text-sm  text-gray-500 ">{item.jobTitle}</span>
            <br />
            <span className="text-sm font-medium text-gray-900 capitalize">
              {item.owner.toLowerCase()}
            </span>
            <br />
          </td>

          <td className="px-4 py-1 whitespace-nowrap">
            <span className="text-sm text-gray-500">{item.network}</span>
            <br />
            <span className="text-sm font-medium text-gray-900">
              {item.number}
            </span>
          </td>

          <td className="px-4 py-1 whitespace-nowrap text-sm font-normal text-gray-500">
            <span
              className={classNames(
                statusStyles[item.status.toLowerCase()],
                "inline-flex items-center px-2 py-1 rounded-md text-md font-medium capitalize"
              )}
            >
              {item.status === "SUCCESSFUL"
                ? `SUCCESSFUL - ${item.response.providerReference}`
                : item.status === "LOGGED"
                ? "approved"
                : item.status === "FATAL FAILED"
                ? "FATAL FAILURE"
                : item.status}
            </span>
          </td>
          <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500">
            <span className="text-gray-900 font-bold">
              {currencyFormatter(item.amount)}
            </span>
          </td>
          {item.status === "SUCCESSFUL" ||
          item.status === "FAILED" ||
          item.status === "FATAL FAILED" ? (
            <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500  my-auto">
              <div className="block cursor-pointer h-7 w-auto">
                <img
                  className="text-gray-400 h-6 w-6 group-hover:text-gray-900"
                  aria-hidden="true"
                  onClick={() =>
                    item.status === "SUCCESSFUL"
                      ? item.company.name === "Not Registered"
                        ? printAirtimeUnregistered(
                            item,
                            itemIdx,
                            getCurrentAccount(),
                            providers.find((p) => p.name === item.network)
                          )
                        : printAirtimeUnregistered(
                            item,
                            itemIdx,
                            getCurrentAccount(),
                            providers.find((p) => p.name === item.network)
                          )
                      : buildFailureTable(transaction, item)
                  }
                  src={pdf}
                  alt="Download"
                />
              </div>
            </td>
          ) : (
            <td> {""}</td>
          )}
        </tr>
      ))
    );
  };

  const dstvRow = () => {
    return (
      transaction.purchaseOrderType === "DSTV" &&
      items.map((item, itemIdx) => (
        <tr key={item.number} className="border-b border-gray-150">
          <td className="px-4 py-1 whitespace-nowrap text-sm font-normal">
            <span className="text-sm text-gray-500">{item.name}</span>
            <br />
            <span className="text-sm font-medium text-gray-900">
              {item.location}
            </span>
          </td>

          <td className="px-4 py-1 whitespace-nowrap">
            <span className="text-sm text-gray-500">{item.number}</span>
            <br />
            <span className="text-sm font-medium text-gray-900 capitalize">
              {item.owner.toLowerCase()}
            </span>
          </td>

          <td className="px-4 py-1 whitespace-nowrap text-sm font-normal text-gray-500">
            <span
              className={classNames(
                statusStyles[item.status.toLowerCase()],
                "inline-flex items-center px-2 py-1 rounded-md text-md font-medium capitalize"
              )}
            >
              {item.status === "SUCCESSFUL"
                ? `SUCCESSFUL - ${item.response.transaction_reference}`
                : item.status === "LOGGED"
                ? "approved"
                : item.status}
            </span>
          </td>
          <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500">
            <span className="text-gray-900 font-bold">
              {currencyFormatter(item.amount)}
            </span>
          </td>
          {item.status === "SUCCESSFUL" ||
          item.status === "FAILED" ||
          item.status === "FATAL FAILED" ? (
            <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500  my-auto">
              <div className="block cursor-pointer h-7 w-auto">
                <img
                  className="text-gray-400 h-6 w-6 group-hover:text-gray-900"
                  aria-hidden="true"
                  onClick={() =>
                    item.status === "SUCCESSFUL"
                      ? item.company.name === "Not Registered"
                        ? printDSTVUnregistered(
                            item,
                            itemIdx,
                            getCurrentAccount(),
                            provider
                          )
                        : printDSTVUnregistered(
                            item,
                            itemIdx,
                            getCurrentAccount(),
                            provider
                          )
                      : buildFailureTable(transaction, item)
                  }
                  src={pdf}
                  alt="Download"
                />
              </div>
            </td>
          ) : (
            <td> {""}</td>
          )}
        </tr>
      ))
    );
  };

  const tableRow: { [key: string]: JSX.Element[] } = {
    electricity: electricityRow(),
    airtime: airtimeRow(),
    dstv: dstvRow(),
  };

  const electricityPrintTable = () => {
    return (
      transaction.purchaseOrderType === "ELECTRICITY" && (
        <>
          <table
            id="my-table"
            className="min-w-full hidden bg-gray-50 border rounded-sm border-gray-200"
          >
            <thead className="sticky bg-gray-200">
              <tr>
                <th
                  scope="col"
                  className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                >
                  <div>Meter Name &amp;</div>
                  <br />
                  <div>Location</div>
                </th>
                <th>
                  Meter Number &amp; <br />
                  Registered Owner
                </th>
                <th
                  scope="col"
                  className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                >
                  Recharge
                </th>
                <th
                  scope="col"
                  className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, itemIdx) => (
                <tr key={item.number} className="border-b border-gray-150">
                  <td className="px-4 py-1 whitespace-wrap">
                    {item.name}
                    <br />

                    {item.location}
                  </td>
                  <td className="px-4 py-1 whitespace-wrap">
                    {item.number}
                    <br />

                    {item.owner}
                  </td>
                  <td className="px-4 py-1 whitespace-nowrap text-sm font-normal text-gray-500">
                    {item.status === "SUCCESSFUL" ? (
                      (item.response as SuccessfulPurchase).creditVendReceipt
                        .keychangetoken1 ? (
                        <div className="flex flex-col">
                          <div>
                            {
                              (item.response as SuccessfulPurchase)
                                .creditVendReceipt.keychangetoken1
                            }
                            ,{" "}
                          </div>
                          <div>
                            {
                              (item.response as SuccessfulPurchase)
                                .creditVendReceipt.keychangetoken2
                            }
                            ,{" "}
                          </div>
                          <div>
                            {
                              (item.response as SuccessfulPurchase)
                                .creditVendReceipt.stsCipher
                            }
                          </div>
                        </div>
                      ) : (
                        <div className="flex flex-col">
                          <div>
                            {
                              (item.response as SuccessfulPurchase)
                                .creditVendReceipt.stsCipher
                            }
                          </div>
                        </div>
                      )
                    ) : (
                      "Failed"
                    )}
                  </td>
                  <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500">
                    <span className="text-gray-900 font-bold">
                      {currencyFormatter(item.amount)}
                    </span>
                  </td>
                </tr>
              ))}
              <tr className="border-b border-gray-150">
                <td className="px-4 py-1 whitespace-wrap"></td>
                <td className="px-4 py-1 whitespace-wrap"></td>
                <td className="block text-right">Total:</td>
                <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500 text-right">
                  {currencyFormatter(
                    items
                      .filter((i) => i.status === "SUCCESSFUL")
                      .map((p) => {
                        return p.amount;
                      })
                      .reduce((acc, amount) => {
                        return acc + +amount;
                      }, 0)
                  )}
                  {/* {
//  words.filter(word => word.length > 6);

       items.filter(i => i.status === "SUCCESSFUL")
      .map((p) => {
        return p.amount;
      })
      .reduce((acc, amount) => {
        return acc + +amount;
      }, 0)
} */}
                </td>
              </tr>
            </tbody>
          </table>

          {failureMeter && (
            <table
              id="failure-table"
              className="min-w-full hidden bg-gray-50 border rounded-sm border-gray-200"
            >
              <thead className="sticky bg-gray-200">
                <tr>
                  <th
                    scope="col"
                    className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                  >
                    <div>Meter Name &amp;</div>
                    <br />
                    <div>Location</div>
                  </th>
                  <th>
                    Meter Number &amp; <br />
                    Registered Owner
                  </th>

                  <th
                    scope="col"
                    className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                  >
                    Recharge
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  key={failureMeter.number}
                  className="border-b border-gray-150"
                >
                  <td className="px-4 py-1 whitespace-wrap">
                    {failureMeter.name}
                    <br />

                    {failureMeter.location}
                  </td>
                  <td className="px-4 py-1 whitespace-wrap">
                    {failureMeter.number}
                    <br />

                    {failureMeter.owner}
                  </td>
                  <td className="px-4 py-1 whitespace-nowrap text-sm font-normal text-gray-500">
                    {failureMeter.status === "SUCCESSFUL"
                      ? (failureMeter.response as SuccessfulPurchase)
                          .creditVendReceipt.stsCipher
                      : "Failed"}
                  </td>
                  <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500">
                    <span className="text-gray-900 font-bold">
                      {currencyFormatter(failureMeter.amount)}
                    </span>
                  </td>
                </tr>
                <tr className="border-b border-gray-150">
                  <td
                    colSpan={4}
                    className="px-4 py-1 whitespace-wrap text-sm font-medium text-gray-500"
                  >
                    Reason: {failureMeter.response.description}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </>
      )
    );
  };

  const airtimePrintTable = () => {
    return (
      transaction.purchaseOrderType === "AIRTIME" && (
        <>
          <table
            id="my-table"
            className="min-w-full hidden bg-gray-50 border rounded-sm border-gray-200"
          >
            <thead className="sticky bg-gray-200">
              <tr>
                <th
                  scope="col"
                  className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                >
                  <div>Owner &amp; </div>
                  <br />
                  <div>Job Title</div>
                </th>
                <th
                  scope="col"
                  className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                >
                  <div>Number &amp; </div>
                  <br />
                  <div>Network </div>
                </th>
                <th
                  scope="col"
                  className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                >
                  Status &amp; Serial Number
                </th>
                <th
                  scope="col"
                  className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, itemIdx) => (
                <tr key={item.number} className="border-b border-gray-150">
                  <td className="px-4 py-1 whitespace-wrap">
                    {item.owner}
                    <br />
                    {item.jobTitle}
                  </td>
                  <td className="px-4 py-1 whitespace-wrap">
                    {item.number}
                    <br />
                    {item.network}
                  </td>
                  <td className="px-4 py-1 whitespace-nowrap text-sm font-normal text-gray-500">
                    {item.status === "SUCCESSFUL"
                      ? `SUCCESSFUL - ${item.response.providerReference}`
                      : "Failed"}
                  </td>
                  <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500">
                    <span className="text-gray-900 font-bold">
                      {currencyFormatter(item.amount)}
                    </span>
                  </td>
                </tr>
              ))}
              <tr className="border-b border-gray-150">
                <td className="px-4 py-1 whitespace-wrap"></td>
                <td className="px-4 py-1 whitespace-wrap"></td>
                <td className="block text-right">Total:</td>
                <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500 text-right">
                  {currencyFormatter(
                    items
                      .filter((i) => i.status === "SUCCESSFUL")
                      .map((p) => {
                        return p.amount;
                      })
                      .reduce((acc, amount) => {
                        return acc + +amount;
                      }, 0)
                  )}
                </td>
              </tr>
            </tbody>
          </table>

          {failureMeter && (
            <table
              id="failure-table"
              className="min-w-full hidden bg-gray-50 border rounded-sm border-gray-200"
            >
              <thead className="sticky bg-gray-200">
                <tr>
                  <th
                    scope="col"
                    className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                  >
                    <div>Owner &amp;</div>
                    <div>Job Title </div>
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                  >
                    <div>Number &amp;</div>
                    <div>Network</div>
                  </th>

                  <th
                    scope="col"
                    className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                  >
                    Recharge
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  key={failureMeter.number}
                  className="border-b border-gray-150"
                >
                  <td className="px-4 py-1 whitespace-wrap">
                    {failureMeter.owner}
                    <br />

                    {failureMeter.jobTitle}
                  </td>
                  <td className="px-4 py-1 whitespace-wrap">
                    {failureMeter.number}
                    <br />
                    {failureMeter.network}
                  </td>
                  <td className="px-4 py-1 whitespace-nowrap text-sm font-normal text-gray-500">
                    {failureMeter.status === "SUCCESSFUL"
                      ? `${failureMeter.number} - SUCCESSFUL`
                      : "Failed"}
                  </td>
                  <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500">
                    <span className="text-gray-900 font-bold">
                      {currencyFormatter(failureMeter.amount)}
                    </span>
                  </td>
                </tr>
                <tr className="border-b border-gray-150">
                  <td
                    colSpan={4}
                    className="px-4 py-1 whitespace-wrap text-sm font-medium text-gray-500"
                  >
                    Reason: {failureMeter.response.description}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </>
      )
    );
  };

  const dstvPrintTable = () => {
    return (
      transaction.purchaseOrderType === "DSTV" && (
        <>
          <table
            id="my-table"
            className="min-w-full hidden bg-gray-50 border rounded-sm border-gray-200"
          >
            <thead className="sticky bg-gray-200">
              <tr>
                <th
                  scope="col"
                  className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                >
                  <div>Smartcard Name &amp;</div>
                  <br />
                  <div>Location</div>
                </th>
                <th>
                  Smartcard Number &amp; <br />
                  Owner
                </th>
                <th
                  scope="col"
                  className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                >
                  Status &amp; Reference
                </th>
                <th
                  scope="col"
                  className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {transaction.purchaseOrderType === "DSTV" &&
                items.map((item, itemIdx) => (
                  <tr key={item.number} className="border-b border-gray-150">
                    <td className="px-4 py-1 whitespace-wrap">
                      {item.name}
                      <br />

                      {item.location}
                    </td>
                    <td className="px-4 py-1 whitespace-wrap">
                      {item.number}
                      <br />

                      {item.owner}
                    </td>
                    <td className="px-4 py-1 whitespace-nowrap text-sm font-normal text-gray-500">
                      {item.status === "SUCCESSFUL"
                        ? `SUCCESSFUL - ${item.response.transaction_reference}`
                        : "Failed"}
                    </td>
                    <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500">
                      <span className="text-gray-900 font-bold">
                        {currencyFormatter(
                          items
                            .filter((i) => i.status === "SUCCESSFUL")
                            .map((p) => {
                              return p.amount;
                            })
                            .reduce((acc, amount) => {
                              return acc + +amount;
                            }, 0)
                        )}
                      </span>
                    </td>
                  </tr>
                ))}
              <tr className="border-b border-gray-150">
                <td className="px-4 py-1 whitespace-wrap"></td>
                <td className="px-4 py-1 whitespace-wrap"></td>
                <td className="block text-right">Total:</td>
                <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500 text-right">
                  {currencyFormatter(transaction.amount)}
                </td>
              </tr>
            </tbody>
          </table>

          {failureMeter && (
            <table
              id="failure-table"
              className="min-w-full hidden bg-gray-50 border rounded-sm border-gray-200"
            >
              <thead className="sticky bg-gray-200">
                <tr>
                  <th
                    scope="col"
                    className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                  >
                    <div>Smartcard Name &amp;</div>
                    <br />
                    <div>Location</div>
                  </th>
                  <th>
                    Smartcard Number &amp; <br />
                    Owner
                  </th>

                  <th
                    scope="col"
                    className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                  >
                    Recharge
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-1 text-left text-sm font-medium text-gray-600 tracking-wide"
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  key={failureMeter.number}
                  className="border-b border-gray-150"
                >
                  <td className="px-4 py-1 whitespace-wrap">
                    {failureMeter.name}
                    <br />

                    {failureMeter.location}
                  </td>
                  <td className="px-4 py-1 whitespace-wrap">
                    {failureMeter.number}
                    <br />

                    {failureMeter.owner}
                  </td>
                  <td className="px-4 py-1 whitespace-nowrap text-sm font-normal text-gray-500">
                    {/* {failureMeter.status === "SUCCESSFUL"
                      ? (failureMeter.response as SuccessfulPurchase)
                          .creditVendReceipt.stsCipher
                      : "Failed"} */}

                    {failureMeter.status === "SUCCESSFUL"
                      ? `${failureMeter.number} - SUCCESSFUL`
                      : `${failureMeter.number} - FAILED`}
                  </td>
                  <td className="px-4 py-1 whitespace-nowrap text-sm text-gray-500">
                    <span className="text-gray-900 font-bold">
                      {currencyFormatter(failureMeter.amount)}
                    </span>
                  </td>
                </tr>
                <tr className="border-b border-gray-150">
                  <td
                    colSpan={4}
                    className="px-4 py-1 whitespace-wrap text-sm font-medium text-gray-500"
                  >
                    Reason: {failureMeter.response.description}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </>
      )
    );
  };

  const printTable: { [key: string]: JSX.Element } = {
    electricity: electricityPrintTable(),
    airtime: airtimePrintTable(),
    dstv: dstvPrintTable(),
  };

  return (
    <>
      {items && (
        <div className="overflow-hidden w-full">
          <div className="flex flex-col">
            <div className=" overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-1 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                {/* Description list*/}
                <section aria-labelledby="purchase-request-approval-title">
                  <div className="bg-white py-4 px-6 shadow shadow-sm ">
                    <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
                      <div className="lg:col-span-6">
                        <h2 className="text-lg leading-6 font-medium text-gray-900">
                          Status
                        </h2>
                      </div>
                      <div className="lg:col-span-6 text-right">
                        <span
                          className={classNames(
                            statusStyles[transaction.status.toLowerCase()],
                            "inline-flex items-center px-5 py-1 rounded-md text-md font-medium capitalize"
                          )}
                        >
                          {transaction.status.toLowerCase()}
                        </span>
                      </div>
                    </div>

                    <div className="border-t border-gray-200 py-4 mt-3 mb-3 ">
                      <div className=" pb-5">
                        <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
                          <div className="lg:col-span-6">
                            <h2
                              id="purchase-request-approval-title"
                              className="text-md leading-6 font-medium text-gray-900"
                            >
                              Purchase Order Details
                            </h2>
                          </div>
                          <div className="lg:col-span-6 ml-auto">
                            {items.filter((t) => t.status !== "LOGGED").length >
                            0 ? (
                              <div className="block cursor-pointer w-auto mr-8">
                                <img
                                  className="text-gray-400 h-6 w-6 group-hover:text-gray-900"
                                  aria-hidden="true"
                                  onClick={() => print(transaction)}
                                  src={pdf}
                                  alt="Download"
                                />
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-3">
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-600">
                            Order Reference
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {transaction.purchaseOrderReference}
                          </dd>
                        </div>
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-600">
                            Purchase Number
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {transaction.purchaseOrderNo}
                          </dd>
                        </div>
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-700">
                            Amount
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {currencyFormatter(transaction.amount)}
                          </dd>
                        </div>
                        {/* <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-700">
                            Items in Order
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {items.length}
                          </dd>
                        </div> */}
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-700">
                            Submitted By
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {transaction.initiator}
                          </dd>
                        </div>
                        <div className="sm:col-span-1">
                          <dt className="text-sm font-medium text-gray-700">
                            Date of Submission
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900">
                            {format(transaction.date, "yyyy-MM-dd HH:mm:ss")}
                          </dd>
                        </div>
                      </dl>
                    </div>
                    <div className="overflow-hidden">
                      <table className="min-w-full bg-gray-50 border rounded-sm border-gray-200">
                        <thead className="sticky bg-gray-200">
                          <tr>
                            {
                              tableHeader[
                                transaction.purchaseOrderType.toLowerCase()
                              ]
                            }
                          </tr>
                        </thead>
                        <tbody>
                          {
                            tableRow[
                              transaction.purchaseOrderType.toLowerCase()
                            ]
                          }
                        </tbody>
                      </table>

                      {printTable[transaction.purchaseOrderType.toLowerCase()]}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      )}
      {!items && <Loading />}
    </>
  );
}
